var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import LocalizedStrings from 'react-localization';
import en from './localization/en.json';
export var defaultLocalizationProps = {
    en: en,
};
function downloadLanguage(countryCode) {
    switch (countryCode) {
        case 'ar':
            return import(
            /* webpackChunkName: "localization-ar" */ './localization/ar.json');
        case 'arc':
        case 'fa':
        case 'he':
        case 'yi':
        case 'ur':
        case 'en':
            return import(
            /* webpackChunkName: "localization-en" */ './localization/en.json');
        case 'no':
            return import(
            /* webpackChunkName: "localization-no" */ './localization/no.json');
        case 'sv':
            return import(
            /* webpackChunkName: "localization-sv" */ './localization/sv.json');
        case 'fi':
            return import(
            /* webpackChunkName: "localization-fi" */ './localization/fi.json');
        case 'da':
            return import(
            /* webpackChunkName: "localization-da" */ './localization/da.json');
        case 'lt':
            return import(
            /* webpackChunkName: "localization-lt" */ './localization/lt.json');
        case 'de':
            return import(
            /* webpackChunkName: "localization-de" */ './localization/de.json');
        case 'fr':
            return import(
            /* webpackChunkName: "localization-fr" */ './localization/fr.json');
        case 'et':
            return import(
            /* webpackChunkName: "localization-et" */ './localization/et.json');
        case 'cs':
            return import(
            /* webpackChunkName: "localization-cs" */ './localization/cs.json');
        case 'pl':
            return import(
            /* webpackChunkName: "localization-pl" */ './localization/pl.json');
        case 'sk':
            return import(
            /* webpackChunkName: "localization-sk" */ './localization/sk.json');
        case 'es':
            return import(
            /* webpackChunkName: "localization-es" */ './localization/es.json');
        case 'nl':
            return import(
            /* webpackChunkName: "localization-nl" */ './localization/nl.json');
        case 'it':
            return import(
            /* webpackChunkName: "localization-it" */ './localization/it.json');
        case 'pt':
            return import(
            /* webpackChunkName: "localization-pt" */ './localization/pt.json');
        case 'lv':
            return import(
            /* webpackChunkName: "localization-lv" */ './localization/lv.json');
        case 'is':
            return import(
            /* webpackChunkName: "localization-is" */ './localization/is.json');
        case 'zh':
            return import(
            /* webpackChunkName: "localization-zh" */ './localization/zh.json');
        // tslint:enable: no-commented-out-code
        default:
            return Promise.reject(new Error("unsupported language ".concat(countryCode)));
    }
}
export var strings = new LocalizedStrings(defaultLocalizationProps, {
    logsEnabled: false,
    loadLanguage: function (countryCode) {
        downloadLanguage(countryCode)
            .then(function (_a) {
            var _b;
            var language = _a.default;
            var content = strings.getContent();
            strings.setContent(__assign(__assign({}, content), (_b = {}, _b[countryCode] = __assign(__assign({}, language), content[countryCode]), _b)), false);
            strings.setLanguage(countryCode, false);
        })
            .catch(function () {
            /* swallow */
        });
    },
});
